/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\CdrXmlPreviewModal.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the CDR Settings module.
----------------------------------------------------------------*/


import { Copy } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useI18n } from '../../../hooks/useI18n';

interface Props {
    xml: string;
    onCopy: () => void;
    onClose: () => void;
}

export function CdrXmlPreviewModal({ xml, onCopy, onClose }: Props) {
    const { t } = useI18n();
    if (!xml) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 px-4">
            <div className="w-full max-w-4xl max-h-[80vh] overflow-hidden rounded-lg border border-border bg-card shadow-lg">
                <div className="flex items-start justify-between border-b border-border/60 p-4">
                    <div>
                        <h3 className="text-lg font-semibold text-foreground">{t('cdrSettings.xmlPreview.title')}</h3>
                        <p className="text-sm text-muted-foreground">{t('cdrSettings.xmlPreview.description')}</p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={onClose}>{t('cdrSettings.xmlPreview.close')}</Button>
                </div>
                <div className="max-h-[60vh] overflow-auto bg-muted/40 p-4">
                    <pre className="whitespace-pre-wrap font-mono text-sm text-foreground">{xml}</pre>
                </div>
                <div className="flex justify-end gap-2 border-t border-border/60 bg-muted/30 p-4">
                    <Button variant="outline" size="sm" onClick={onCopy}>
                        <Copy className="mr-2 h-4 w-4" />{t('cdrSettings.xmlPreview.copy')}
                    </Button>
                    <Button size="sm" onClick={onClose}>{t('cdrSettings.xmlPreview.close')}</Button>
                </div>
            </div>
        </div>
    );
}
